import { Th, Thead, Tr } from "@chakra-ui/react";

const PointsDistributionHeader = () => {
  return (
    <Thead
      border="hidden"
      h="40px"
      borderBottom="1px solid"
      fontWeight="600"
      fontSize={{ base: "12px", md: "16px" }}
    >
      <Tr>
        <Th paddingLeft={0} paddingRight="4px">
          Assets
        </Th>
        <Th textAlign="end" w="30%" paddingLeft={0} paddingRight="4px">
          Kernel Points
        </Th>
        {/* <Th textAlign="end" w="30%" paddingEnd={0}>
          EigenLayer Points
        </Th> */}
      </Tr>
    </Thead>
  );
};

export default PointsDistributionHeader;
